import { Component, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { URLS } from '../../constant/interface';
import { _MSGTYPES } from '../../constant/msgType';
import { isJsonString } from '../../utils/common';

/* 入口数据model */
interface SourceItem {
  isMo: boolean;
  msgType: number;
  content: any;
}

interface MessageItem {
  name?: string;
  msgType: number;
  contentType: number;
  content: any;
  title?: string;
}

/* 解析后的内容 */
interface ContentItem {
  contentType: number;
  content: any;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-msg-content',
  templateUrl: './icc-msg-content.component.html',
  styleUrls: ['./icc-msg-content.component.less'],
})
export class IccMsgContentComponent implements OnChanges {
  constructor(private cdr: ChangeDetectorRef) {}
  // 数据源
  @Input() message: SourceItem;

  // 是否弹出modal显示
  @Input() isModal = false;

  // model title
  @Input() title = '标题';

  // 是否是时光轴展示
  @Input() isTimeline: boolean;

  // 是否是消息上行
  // @Input() isMO: boolean;

  // 异常图片地址
  @Input() errorImgUrl = './assets/images/nothing/invalid_white.png';

  @Output() wechatClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  // 列表显示Url前缀
  downloadUrl = 'icc/service/common/attachment/download?';

  targetItem: MessageItem = {
    name: '',
    msgType: 100,
    contentType: 0,
    content: '',
  };

  // 自定义内容类型
  contentTypes = {
    text: -1, // 纯文本，无格式信息
    html: 0, // 会解析格式信息及标签信息
    image: 1,
    audio: 2,
    video: 3,
    wechatList: 4,
    _5g: 5,
  };
  // 地址前缀
  baseUrl = URLS.attachment.url + '?';

  menuItem: any;

  ngOnChanges() {
    if (!this.message) {
      console.log('数据有误');
      return false;
    }
    this.targetItem = this.getParsedContent();
    console.log(`this.targetItem`, this.targetItem);
  }

  /* 获取解析后的消息内容 */
  getParsedContent() {
    let { isMo, msgType, content } = this.message;
    let parsedItem: any = {
      msgType,
    };
    console.log(this.message);
    switch (true) {
      case isMo && msgType === _MSGTYPES.MT.SMS.type:
        parsedItem.contentType = this.contentTypes.html;
        parsedItem.content = content || '【短信内容为空】';
        break;
      case isMo && msgType === _MSGTYPES.MT.EMAIL.type:
        parsedItem.contentType = this.contentTypes.html;
        const contentObj = JSON.parse(content);
        parsedItem.content = contentObj.content || '【邮件内容为空】';
        break;
      case isMo && msgType === _MSGTYPES.MT.VOICE.type:
        parsedItem.contentType = this.contentTypes.audio;
        parsedItem.content = this.baseUrl + JSON.parse(content).content.content;
        break;
      case isMo && msgType === _MSGTYPES.MT.WECHAT.type:
        if (!this.isJsonString(content)) {
          parsedItem.contentType = this.contentTypes.html;
          parsedItem.content = content || '【微信内容为空】';
        } else {
          let itemInfo = JSON.parse(content);
          switch (itemInfo.type) {
            case 'text':
              parsedItem.contentType = this.contentTypes.html;
              parsedItem.content = itemInfo.content || '【微信内容为空】';
              break;
            case 'image':
              parsedItem.contentType = this.contentTypes.image;
              parsedItem.content = [
                {
                  name: '',
                  url: this.baseUrl + itemInfo.content,
                },
              ];
              break;
            case 'voice':
              parsedItem.contentType = this.contentTypes.audio;
              parsedItem.content = this.baseUrl + itemInfo.content;
              break;
            case 'video':
              parsedItem.contentType = this.contentTypes.video;
              parsedItem.content = this.baseUrl + itemInfo.content;
              break;
            case 'position':
            case 'link':
              parsedItem.contentType = this.contentTypes.text;
              parsedItem.content = '【收到不支持的消息，暂无法显示】';
              break;
            default:
              break;
          }
        }
        break;
      case isMo && msgType === _MSGTYPES.MT._5G.type:
        if (!this.isJsonString(content)) {
          parsedItem.contentType = this.contentTypes.html;
          parsedItem.content = content || '【5G内容为空】';
        } else {
          let itemInfo = JSON.parse(content);
          switch (itemInfo.type) {
            case 'text':
              parsedItem.contentType = this.contentTypes.html;
              parsedItem.content = itemInfo.content || '【5G内容为空】';
              break;
            case 'image':
              parsedItem.contentType = this.contentTypes.image;
              parsedItem.content = [
                {
                  name: '',
                  url: this.baseUrl + itemInfo.content,
                },
              ];
              break;
            default:
              break;
          }
        }
        break;
      case isMo && msgType === _MSGTYPES.MT.WORKWX.type:
        if (!this.isJsonString(content)) {
          parsedItem.contentType = this.contentTypes.html;
          parsedItem.content = content || '【企业微信内容为空】';
        } else {
          let itemInfo = JSON.parse(content);
          switch (itemInfo.type) {
            case 'text':
              parsedItem.contentType = this.contentTypes.html;
              parsedItem.content = itemInfo.content || '【企业微信内容为空】';
              break;
            case 'image':
              parsedItem.contentType = this.contentTypes.image;
              parsedItem.content = [
                {
                  name: '',
                  url: this.baseUrl + itemInfo.content,
                },
              ];
              break;
            case 'voice':
              parsedItem.contentType = this.contentTypes.audio;
              parsedItem.content = this.baseUrl + itemInfo.content;
              break;
            case 'video':
              parsedItem.contentType = this.contentTypes.video;
              parsedItem.content = this.baseUrl + itemInfo.content;
              break;
            case 'position':
            case 'link':
              parsedItem.contentType = this.contentTypes.text;
              parsedItem.content = '【收到不支持的消息，暂无法显示】';
              break;
            default:
              break;
          }
        }
        break;
      case isMo && msgType === _MSGTYPES.MT.TIKTOK.type:
        parsedItem.contentType = this.contentTypes.html;
        parsedItem.content = content || '【抖音私信内容为空】';
        break;
      case !isMo && (msgType === _MSGTYPES.MT.SMS.type || msgType === _MSGTYPES.MT.VOICE.type):
        // 注：下行的语音为文本信息
        parsedItem.contentType = this.contentTypes.text;
        parsedItem.content = content || (msgType === _MSGTYPES.MT.SMS.type ? '【短信内容为空】' : '【语音内容为空】');
        break;
      case !isMo && msgType === _MSGTYPES.MT.WECHAT.type:
        let tempContent;
        content = content.replace(/[\r\n]/g, ''); //去掉回车换行
        if (this.isJsonString(content)) {
          tempContent = JSON.parse(content);
          console.log(tempContent[0]);
          switch (tempContent[0].contentType) {
            case 1:
              // 微信图文
              if (tempContent instanceof Array) {
                tempContent.forEach((item, index) => {
                  if (!index) {
                    item.selected = true;
                    this.menuItem = item;
                  }
                  if (item.mediaList instanceof Array) {
                    item.thumb = this.baseUrl + item.mediaList[0].url;
                  }
                });
              }
              parsedItem.contentType = this.contentTypes.wechatList;
              parsedItem.content = tempContent;
              break;
            case 2:
              // 微信文本
              parsedItem.contentType = this.contentTypes.html;
              parsedItem.content = tempContent[0].content || '【微信内容为空】';
              break;
            case 3:
              // 微信单张图片
              parsedItem.contentType = this.contentTypes.image;
              parsedItem.content = [
                {
                  name: '',
                  url: this.baseUrl + tempContent[0].mediaList[0].url,
                },
              ];
              break;
            default:
              break;
          }
        } else {
          // 微信消息模板
          parsedItem.contentType = this.contentTypes.html;
          parsedItem.content = content || '【微信内容为空】';
        }
        break;
      case !isMo && msgType === _MSGTYPES.MT.EMAIL.type:
        parsedItem.contentType = this.contentTypes.html;
        if (this.isJsonString(content)) {
          parsedItem.content = JSON.parse(content)[0].content || '【邮件内容为空】';
        } else {
          parsedItem.content = content || '【邮件内容为空】';
        }
        break;
      case !isMo && msgType === _MSGTYPES.MT.JPUSH.type:
        parsedItem.contentType = this.contentTypes.html;
        // 融合发送-选择模板：content为字符串；下行内容查看时，是json数组
        let _content = '';
        if (this.isJsonString(content)) {
          _content = JSON.parse(content)[0].content;
        } else {
          _content = content;
        }
        parsedItem.content = _content || '【极光推送内容为空】';
        break;
      case !isMo && msgType === _MSGTYPES.MT.TIKTOK.type:
        let jsonContent;
        if (this.isJsonString(content)) {
          jsonContent = JSON.parse(content);
          if (jsonContent instanceof Array && jsonContent.length) {
            switch (jsonContent[0].contentType) {
              case 3:
                // 图片
                parsedItem.contentType = this.contentTypes.image;
                const imgList = [];
                const tempArr = jsonContent[0].mediaList;
                if (tempArr instanceof Array) {
                  tempArr.forEach(imgItem => {
                    imgList.push({
                      name: imgItem.name,
                      url: this.baseUrl + imgItem.url,
                    });
                  });
                }
                parsedItem.content = imgList;
                break;
              case 4:
                // 抖音单视频
                parsedItem.contentType = this.contentTypes.video;
                parsedItem.content = this.baseUrl + jsonContent[0].mediaList[0].url;
                // Edit 2020-05-19 增加title字段
                parsedItem.name = jsonContent[0].mediaList[0].name;
                break;
              default:
                parsedItem.contentType = this.contentTypes.text;
                parsedItem.content = jsonContent[0].content.text;
                break;
            }
          } else {
            switch (jsonContent.contentType) {
              case 3:
                // 图片
                parsedItem.contentType = this.contentTypes.image;
                const imgList = [];
                const tempArr = jsonContent.mediaList;
                if (tempArr instanceof Array) {
                  tempArr.forEach(imgItem => {
                    imgList.push({
                      name: imgItem.name,
                      url: this.baseUrl + imgItem.url,
                    });
                  });
                }
                parsedItem.content = imgList;
                break;
              case 4:
                // 抖音单视频
                parsedItem.contentType = this.contentTypes.video;
                parsedItem.content = this.baseUrl + jsonContent.mediaList[0].url;
                // Edit 2020-05-19 增加title字段
                parsedItem.name = jsonContent.mediaList[0].name;
                break;
              default:
                break;
            }
          }
        }
        break;
      case !isMo && msgType === _MSGTYPES.MT._5G.type:
        parsedItem.contentType = this.contentTypes._5g;
        tempContent = isJsonString(content) ? JSON.parse(content) : content;
        parsedItem.content = tempContent instanceof Array ? tempContent[0] : tempContent;
        break;
      case !isMo && msgType === _MSGTYPES.MT.WORKWX.type:
        if (!this.isJsonString(content)) {
          parsedItem.contentType = this.contentTypes.text;
          if (content.contentType === 0) {
            parsedItem.contentType = this.contentTypes.text;
          } else if (content.contentType === 1) {
            parsedItem.contentType = this.contentTypes.html;
            parsedItem.content = content.content;
          } else if (content.contentType === 2) {
            parsedItem.contentType = this.contentTypes.text;
            parsedItem.content = content.content;
          } else if (content.contentType === 3) {
            parsedItem.contentType = this.contentTypes.image;
            parsedItem.content = [{ url: this.downloadUrl + content.mediaList[0].url }];
          } else if (content.contentType === 4) {
            parsedItem.contentType = this.contentTypes.video;
            parsedItem.content = this.downloadUrl + content.mediaList[0].url;
          } else if (content.contentType === 5) {
            parsedItem.contentType = this.contentTypes.audio;
            parsedItem.content = this.downloadUrl + content.mediaList[0].url;
          }
          // parsedItem.content = content;
        } else {
          const _temp = JSON.parse(content);
          const _tempContent = _temp instanceof Array ? _temp[0] : _temp;
          let itemInfo = _tempContent;
          switch (itemInfo.contentType) {
            case 1:
              // 微信图文
              if (_temp instanceof Array) {
                _temp.forEach((item, index) => {
                  if (!index) {
                    item.selected = true;
                    this.menuItem = item;
                  }
                  if (item.mediaList instanceof Array) {
                    item.thumb = this.baseUrl + item.mediaList[0].url;
                  }
                });
              }
              parsedItem.contentType = this.contentTypes.wechatList;
              parsedItem.content = _temp;
              break;
            case 2:
              // 文字
              parsedItem.contentType = this.contentTypes.text;
              parsedItem.content = itemInfo.content;
              break;
            case 3:
              // 图片
              parsedItem.contentType = this.contentTypes.image;
              const _imgItem = itemInfo.mediaList[0];
              parsedItem.content = [
                {
                  name: _imgItem.name,
                  url: this.baseUrl + _imgItem.url,
                },
              ];
              break;
            case 4:
              // 视频
              parsedItem.contentType = this.contentTypes.video;
              if (itemInfo.mediaList && itemInfo.mediaList.length) {
                parsedItem.content = this.baseUrl + itemInfo.mediaList[0].url;
              }
              break;
            case 5:
              // 语音
              parsedItem.contentType = this.contentTypes.audio;
              if (itemInfo.mediaList && itemInfo.mediaList.length) {
                parsedItem.content = this.baseUrl + itemInfo.mediaList[0].url;
              }
              break;
            default:
              break;
          }
        }
        break;
      default:
        break;
    }

    // 统一对content中的格式和图片大小进行处理
    if (parsedItem.contentType === this.contentTypes.html) {
      /*
        this.contentTypes.html类型下，注意：
        有些文本是含有格式信息的，此处需要将\r\n替换为br，如下行微信文本
        但是需要解析的html字符串却是不能讲标签的\r\n替换为br，否则会多很多空行，如上行邮件
        故此处【替换】应分情况（通过检测是否含有html标签）
       */
      const reg = /<[^>]+>/g;
      if (!reg.test(parsedItem.content)) {
        parsedItem.content = parsedItem.content ? parsedItem.content.replace(/[\r\n]/g, '<br/>') : '';
      }

      parsedItem.content = parsedItem.content.replace(/<img/g, "<img style='max-width: 100%;'");
    } else if (parsedItem.contentType === this.contentTypes.wechatList) {
      parsedItem.content.forEach(item => {
        item.content = item.content.replace(/<img/g, "<img style='max-width: 100%;'");
      });
    }

    return parsedItem;
  }

  /* 判断是否是json格式 */
  isJsonString(jsonStr): boolean {
    try {
      if (typeof JSON.parse(jsonStr) === 'object') {
        return true;
      }
    } catch (e) {}
    return false;
  }
  /* 图文点击事件 */
  selectedChange(item) {
    this.menuItem = item;
    this.wechatClick.emit(item);
  }
  closeModel() {
    this.close.emit();
  }
}
